// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"2e40f810","249":"a74250c5","396":"e0240847","655":"493e975e","831":"1ab88520","981":"02d8b1de"}[chunkId] + ".chunk.css";
};